export default __webpack_public_path__ + "static/media/evan-rachel-wood.c75c5aaa.jpg";